import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../views/Home.vue'
import Lobby from '../views/Lobby.vue'
import LobbyNoVideo from '../views/LobbyNoVideo.vue'

import Sessions from '../views/Sessions.vue'
import SessionsBackup from '../views/SessionsBackup.vue'
import SessionsTest from '../views/SessionsTest.vue'

import Speakers from '../views/Speakers.vue'

/*import VeeamBooth from '../views/VeeamBooth.vue'*/
import Community from '../views/Community.vue'
/*import Trivia from '../views/Trivia.vue'
import SocialWall from '../views/SocialWall.vue'*/
import PDFViewer from '../views/PDFViewer.vue'
import EventSurvey from '../views/EventSurvey.vue'
import GartnerFAQ from '../views/GartnerFAQ.vue'

import HelpDesk from '../views/HelpDesk.vue'
import FAQ from '../views/FAQ.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lobby',
    name: 'Lobby',
    component: Lobby
  },
  {
    path: '/thelobby',
    name: 'LobbyNoVideo',
    component: LobbyNoVideo
  },
  {
    path: '/agenda',
    name: 'Sessions',
    component: Sessions
  },
  {
    path: '/sessionsbackup',
    name: 'SessionsBackup',
    component: SessionsBackup
  },
  {
    path: '/sessionstest',
    name: 'SessionsTest',
    component: SessionsTest
  },
  {
    path: '/speakers',
    name: 'Speakers',
    component: Speakers
  },/*
  {
    path: '/veeambooth',
    name: 'VeeamBooth',
    component: VeeamBooth
  },*/
  {
    path: '/community',
    name: 'Community',
    component: Community
  },/*
  {
    path: '/trivia',
    name: 'Trivia',
    component: Trivia
  },
  {
    path: '/socialwall',
    name: 'SocialWall',
    component: SocialWall
  },*/
  {
    path: '/pdfviewer',
    name: 'PDFViewer',
    component: PDFViewer
  },
  {
    path: '/eventsurvey',
    name: 'EventSurvey',
    component: EventSurvey
  },
  {
    path: '/gartnerfaq',
    name: 'GartnerFAQ',
    component: GartnerFAQ
  },
  {
    path: '/helpdesk',
    name: 'HelpDesk',
    component: HelpDesk
  },
  {
    path: '/faq',
    name: 'FAQ',
    component: FAQ
  }

]

const router = new VueRouter({
  hashbang: false,
  history: true,
  linkActiveClass: 'active',
  transitionOnLoad: true,
  root: '/',
  mode: 'history',
  routes
})
let localStore = localStorage.getItem('magicLink');
let localStore_ticketId = localStorage.getItem('ticketId');

var isAuth=false;

if(localStore_ticketId !== null && localStore !== null){

  isAuth=true

}
//var ref=this
router.beforeEach((to, from, next) => {

  console.log("hh")

  if(to.name=='Lobby' || to.name == 'Home'){
    console.log("router-"+to.name)
    next()
  }else{
    if (isAuth) {
      console.log("success")
      next();
    } else {
      next({ name: 'Lobby' });
      console.log("failed")

    }
  }

});



export default router